module.exports = __webpack_public_path__ + "static/stats-8f7f39715bc0d9d8d3298bd26170fc68.png";